module.exports = __webpack_public_path__ + "static/media/SVG_write.9b4e960d.svg";